export class MenueItems {
    menusList = [
        {
            name: "Dashboard",
            icon: "fas fa-tachometer-alt",
            module: "dashboard",
            class: "",
            path: "view",
            permission: ["Businesses", "CodDashboard"],
            submenue: [
                {
                    name: "Dashboard",
                    path: "view",
                    permission: "Business.Read",
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                {
                    name: "COD Dashboard",
                    path: "cod",
                    permission: "Dashboard.CodDashboard.Read",
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                // {
                //     name: "Delivery Dashboard",
                //     path: "delivery-dashboard",
                //     permission: "Dashboard.DashboardDelivery.Read",
                //     icon: "fa fa-minus",
                //     class: "break-able-menu",
                //     submenue: [],
                // },
                // {
                //     name: "COD Station Submission",
                //     path: "cod-submission-dashboard",
                //     permission: "Dashboard.StationCodDashboard.Read",
                //     icon: "fa fa-minus",
                //     class: "break-able-menu",
                //     submenue: [],
                // },
            ],
        },
        // {
        //   "name": "COD Dashboard",
        //   "icon": "fas fa-money-bill",
        //   "module": "dashboard",
        //   "class": "",
        //   "path": "cod",
        //   "permission": ["Dashboard.CodDashboard.Read"],
        //   "submenue": null
        // },
        {
            name: "User Profile",
            icon: "fa fa-user-circle",
            module: "user-profile",
            class: "",
            path: "",
            permission: ["Users"],
            submenue: null,
        },
        {
            name: "Shipment",
            icon: "fa fa-cube",
            module: "shipment",
            class: "",
            path: "",
            permission: ["Consignments"],
            submenue: [
                {
                    name: "Shipment List",
                    path: "list",
                    permission: "Consignment.Read",
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                // {
                //     name: "Pre Shipment",
                //     path: "pre-shipping/list",
                //     permission: "Consignment.Read",
                //     icon: "fa fa-minus",
                //     class: "break-able-menu",
                //     submenue: [],
                // },
                {
                    name: "Batch List",
                    path: "batch/list",
                    permission: "ConsignmentBatch.Read",
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                {
                    name: "POD Images",
                    path: "pod-images",
                    permission: "ConsignmentMilestone.Download",
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
            ],
        },
        {
            name: "Finance",
            icon: "fa fa-file-invoice-dollar",
            module: "finance",
            class: "",
            path: "",
            permission: ["Invoices", "eTopup", "PaymentRequest"],
            submenue: [
                {
                    name: "Invoice",
                    path: "invoice",
                    permission: "Invoice.Read",
                    roles: null,
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                {
                    name: "e-TopUp",
                    path: "etopup",
                    permission: "eTopup.Read",
                    roles: null,
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                {
                    name: "Payment Request",
                    path: "payment-request-list",
                    permission: "PaymentRequest.Read",
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                }
            ],
        },
        {
            name: "Booking",
            icon: "fas fa-calendar-alt",
            module: "booking",
            class: "",
            path: "list",
            permission: ["Job.Read"],
            submenue: null,
        },
        {
            name: "Retail Inbound Scan",
            icon: "fas fa-caret-square-down",
            module: "retail-inbound",
            class: "",
            path: "scan",
            permission: ["RetailInboundScan.Read"],
            submenue: null,
        },
        {
            name: "eFMX POS",
            icon: "fas fa-calculator",
            module: "pos",
            class: "",
            path: "daily/open",
            permission: ["PosDailyAction"],
            roles: null,
            submenue: [
                {
                    name: "Inbound",
                    path: "pos-inbound/history",
                    permission: "PosDailyAction.Read",
                    roles: null,
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                {
                    name: "Daily POS History",
                    path: "history",
                    permission: "PosPayment.Read",
                    roles: null,
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
            ],
        },
        {
            name: "Manifest",
            icon: "fa fa-file",
            module: "manifest",
            class: "",
            path: "list",
            permission: ["Manifests", "Manifest.Read"],
            submenue: null,
        },
        {
            name: "Address Book",
            icon: "fa fa-address-book",
            module: "address-book",
            class: "",
            path: "",
            permission: ["AddressBook"],
            submenue: [
                {
                    name: "Address Book List",
                    path: "list",
                    permission: "AddressBook.Read",
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                {
                    name: "Import Address Book",
                    path: "create-bulk-address",
                    permission: "AddressBook.Create",
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
            ],
        },
        {
            name: "Company",
            icon: "fa fa-briefcase",
            module: "company",
            class: "",
            path: "list",
            permission: ["Businesses"],
            submenue: null,
        },
        {
            name: "Statements",
            icon: "fa fa-file-invoice-dollar",
            module: "statements",
            class: "",
            path: "",
            permission: ["Transaction.Read", "RetailTransactions.Read"],
            submenue: [
                {
                    name: "Business Transaction",
                    path: "customers",
                    permission: "Report.BusinessTransaction.Read",
                    roles: null,
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                {
                    name: "Inbound Statement",
                    path: "inbound-scan",
                    permission: "RetailTransactions.Read",
                    roles: null,
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
            ],
        },
        {
            name: "Reports",
            icon: "fas fa-chart-line",
            module: "reports",
            class: "",
            path: "list",
            permission: ["Reports"],
            submenue: [
                {
                    name: "Business Transaction",
                    path: "transaction-report",
                    permission: "Report.BusinessTransaction.Read",
                    roles: null,
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
                {
                    name: "Manifest Billing",
                    path: "manifest-billing-report",
                    permission: "Report.ManifestBilling.Read",
                    roles: null,
                    icon: "fa fa-minus",
                    class: "break-able-menu",
                    submenue: [],
                },
            ],
        },
    ];
}
